/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/*Added by JT on Dec14 2023*/
$(document).ready(function () {
  var Wopen = false;
  $(".swym-wishlist").click(function () {
    if ($(".swym-modals-container").length > 0) {
      setTimeout(function () {
        Wopen = true;
        $(".swym-add-to-cart-btn").addClass("wishlist_cart_btn");

        if (Wopen == true) {
          $(".wishlist_cart_btn").click(function () {
            setTimeout(function () {
              $(".swym-close-btn").click();

              fetch(`${window.themeVariables.routes.cartUrl}.js`).then(
                async (response2) => {
                  const cartContent = await response2.json();
                  document.documentElement.dispatchEvent(
                    new CustomEvent("cart:updated", {
                      bubbles: true,
                      detail: {
                        cart: cartContent,
                      },
                    }),
                  );

                  document.documentElement.dispatchEvent(
                    new CustomEvent("cart:refresh", {
                      bubbles: true,
                      detail: {
                        cart: cartContent,
                        openMiniCart:
                          window.themeVariables.settings.cartType === "drawer",
                      },
                    }),
                  );
                },
              );
            }, 500);
          });
        }
      }, 1000);
    }
  });
});

if (!customElements.get("sc-product-accordeon")) {
  class ScProductAccordeon extends HTMLElement {
    static get observedAttributes() {
      return ["data-accordeon-open"];
    }

    connectedCallback() {
      this.head = this.querySelector("[data-accordeon-head]");
      this.body = this.querySelector("[data-accordeon-body]");

      if (!this.head || !this.body) return;

      this.onHeadClick = () => this.toggle();
      this.onBodyTransitionEnd = (event) => {
        if (event.propertyName !== "height") return;
        if (this.isOpen()) this.body.style.height = "auto";
      };

      this.head.addEventListener("click", this.onHeadClick);
      this.body.addEventListener("transitionend", this.onBodyTransitionEnd);

      this.applyState(this.isOpen(), false);
    }

    disconnectedCallback() {
      if (this.head && this.onHeadClick) {
        this.head.removeEventListener("click", this.onHeadClick);
      }

      if (this.body && this.onBodyTransitionEnd) {
        this.body.removeEventListener(
          "transitionend",
          this.onBodyTransitionEnd,
        );
      }
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (
        name !== "data-accordeon-open" ||
        oldValue === newValue ||
        !this.isConnected ||
        !this.body
      )
        return;

      this.applyState(this.isOpen(), true);
    }

    isOpen() {
      if (!this.hasAttribute("data-accordeon-open")) return false;

      const value = this.getAttribute("data-accordeon-open");
      return (
        value === "" || value === "true" || value === "1" || value === "open"
      );
    }

    open() {
      this.setAttribute("data-accordeon-open", "true");
    }

    close() {
      this.setAttribute("data-accordeon-open", "false");
    }

    toggle(forceState) {
      const nextState =
        typeof forceState === "boolean" ? forceState : !this.isOpen();
      this.setAttribute("data-accordeon-open", nextState ? "true" : "false");
    }

    applyState(open, animate = true) {
      this.dataset.accordeonOpen = open ? "true" : "false";

      if (!animate) {
        this.body.style.height = open ? "auto" : "0px";
        return;
      }

      if (open) {
        this.body.style.height = this.body.scrollHeight + "px";
        return;
      }

      if (this.body.style.height === "auto") {
        this.body.style.height = this.body.scrollHeight + "px";
        this.body.offsetHeight;
      }

      requestAnimationFrame(() => {
        this.body.style.height = "0px";
      });
    }
  }

  customElements.define("sc-product-accordeon", ScProductAccordeon);
}

if (!customElements.get("sc-product-accordeon-list")) {
  class ScProductAccordeonList extends HTMLElement {
    connectedCallback() {
      this.onClick = this.onClick.bind(this);
      this.onMutations = this.onMutations.bind(this);
      this.hasManualOpen = false;
      this.manualOpenCheckFrame = null;

      this.addEventListener("click", this.onClick);

      this.observer = new MutationObserver(this.onMutations);
      this.observer.observe(this, {
        subtree: true,
        attributes: true,
        attributeFilter: ["data-accordeon-open"],
      });
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.onClick);

      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      if (this.manualOpenCheckFrame) {
        cancelAnimationFrame(this.manualOpenCheckFrame);
        this.manualOpenCheckFrame = null;
      }
    }

    onClick(event) {
      const head = event.target.closest("[data-accordeon-head]");
      if (!head || !this.contains(head) || !this.isAutoCloseEnabled()) return;

      const activeAccordeon = head.closest("sc-product-accordeon");
      if (!activeAccordeon || !this.contains(activeAccordeon)) return;

      this.manualOpenCheckFrame = requestAnimationFrame(() => {
        this.manualOpenCheckFrame = null;
        if (!this.isAutoCloseEnabled()) return;
        if (!this.isAccordeonOpen(activeAccordeon)) return;

        this.hasManualOpen = true;
        this.closeOthers(activeAccordeon);
      });
    }

    onMutations(mutations) {
      if (!this.isAutoCloseEnabled() || !this.hasManualOpen) return;

      for (const mutation of mutations) {
        const activeAccordeon = mutation.target;

        if (
          !activeAccordeon ||
          activeAccordeon.tagName !== "SC-PRODUCT-ACCORDEON"
        )
          continue;
        if (!this.isAccordeonOpen(activeAccordeon)) continue;

        this.closeOthers(activeAccordeon);
      }
    }

    isAutoCloseEnabled() {
      if (!this.hasAttribute("data-accordeon-auto-close")) return false;

      const value = this.getAttribute("data-accordeon-auto-close");
      return (
        value === "" || value === "true" || value === "1" || value === "on"
      );
    }

    isAccordeonOpen(element) {
      if (!element.hasAttribute("data-accordeon-open")) return false;

      const value = element.getAttribute("data-accordeon-open");
      return (
        value === "" || value === "true" || value === "1" || value === "open"
      );
    }

    closeOthers(activeAccordeon) {
      const accordeons = this.querySelectorAll("sc-product-accordeon");

      accordeons.forEach((accordeon) => {
        if (accordeon === activeAccordeon || !this.isAccordeonOpen(accordeon))
          return;

        if (typeof accordeon.close === "function") {
          accordeon.close();
        } else {
          accordeon.setAttribute("data-accordeon-open", "false");
        }
      });
    }
  }

  customElements.define("sc-product-accordeon-list", ScProductAccordeonList);
}

if (!customElements.get("sc-contact-popup")) {
  class ScContactPopup extends HTMLElement {
    connectedCallback() {
      this.openButton = this.querySelector("[data-sc-contact-open]");
      this.popup = this.querySelector("[data-sc-contact-popup]");
      this.overlay = this.querySelector("[data-sc-contact-overlay]");
      this.closeButton = this.querySelector("[data-sc-contact-close]");

      if (!this.openButton || !this.popup) return;

      this.handleOpen = this.handleOpen.bind(this);
      this.handleClose = this.handleClose.bind(this);

      this.popup.setAttribute("hidden", "");
      this.openButton.addEventListener("click", this.handleOpen);

      if (this.overlay) {
        this.overlay.addEventListener("click", this.handleClose);
      }

      if (this.closeButton) {
        this.closeButton.addEventListener("click", this.handleClose);
      }
    }

    disconnectedCallback() {
      if (this.openButton) {
        this.openButton.removeEventListener("click", this.handleOpen);
      }

      if (this.overlay) {
        this.overlay.removeEventListener("click", this.handleClose);
      }

      if (this.closeButton) {
        this.closeButton.removeEventListener("click", this.handleClose);
      }
    }

    handleOpen() {
      this.popup.removeAttribute("hidden");
    }

    handleClose() {
      this.popup.setAttribute("hidden", "");
    }
  }

  customElements.define("sc-contact-popup", ScContactPopup);
}

if (!customElements.get("sc-product-media-cta-info")) {
  class ScProductMediaCtaInfo extends HTMLElement {
    connectedCallback() {
      this.openButton = this.querySelector("[data-sc-media-cta-info-open]");
      this.popup = this.querySelector("[data-sc-media-cta-info-popup]");
      this.overlay = this.querySelector("[data-sc-media-cta-info-overlay]");
      this.closeButton = this.querySelector("[data-sc-media-cta-info-close]");

      if (!this.openButton || !this.popup) return;

      this.handleOpen = this.handleOpen.bind(this);
      this.handleClose = this.handleClose.bind(this);

      this.popup.setAttribute("hidden", "");
      this.openButton.addEventListener("click", this.handleOpen);

      if (this.overlay) {
        this.overlay.addEventListener("click", this.handleClose);
      }

      if (this.closeButton) {
        this.closeButton.addEventListener("click", this.handleClose);
      }
    }

    disconnectedCallback() {
      if (this.openButton) {
        this.openButton.removeEventListener("click", this.handleOpen);
      }

      if (this.overlay) {
        this.overlay.removeEventListener("click", this.handleClose);
      }

      if (this.closeButton) {
        this.closeButton.removeEventListener("click", this.handleClose);
      }
    }

    handleOpen() {
      this.popup.removeAttribute("hidden");
    }

    handleClose() {
      this.popup.setAttribute("hidden", "");
    }
  }

  customElements.define("sc-product-media-cta-info", ScProductMediaCtaInfo);
}

if (!customElements.get("sc-product-bundle")) {
  const bundleGroups = new Map();

  function findVariantPickerByFormId(formId) {
    return Array.from(document.querySelectorAll("variant-picker")).find(
      (picker) => picker.getAttribute("form-id") === formId,
    );
  }

  function getCurrentProductId(group) {
    if (group.productIdInput && group.productIdInput.value) {
      return String(group.productIdInput.value);
    }

    return group.defaultProductId || "";
  }

  function getDefaultBundleMember(group) {
    const currentProductId = getCurrentProductId(group);

    if (currentProductId) {
      const memberByProductId = Array.from(group.members).find(
        (member) => member.dataset.productId === currentProductId,
      );

      if (memberByProductId) return memberByProductId;
    }

    return (
      Array.from(group.members).find(
        (member) => member.getAttribute("data-active") === "true",
      ) || Array.from(group.members)[0]
    );
  }

  function setActiveMember(group, activeMember) {
    group.members.forEach((member) => {
      member.setAttribute(
        "data-active",
        member === activeMember ? "true" : "false",
      );
    });
  }

  function syncActiveMemberFromInput(group) {
    if (!group || !group.members.size) return;

    const currentVariantId = group.idInput
      ? String(group.idInput.value || "")
      : "";
    const memberByVariant = Array.from(group.members).find(
      (member) => member.dataset.variantId === currentVariantId,
    );
    const activeMember = memberByVariant || getDefaultBundleMember(group);

    if (activeMember) {
      setActiveMember(group, activeMember);
    }
  }

  function setFormVariant(group, variantId) {
    if (!group || !group.idInput || !variantId) return;

    const nextVariantId = String(variantId);

    if (String(group.idInput.value) !== nextVariantId) {
      group.idInput.value = nextVariantId;
      group.idInput.dispatchEvent(new Event("change", { bubbles: true }));
      return;
    }

    syncActiveMemberFromInput(group);
  }

  function getOrCreateGroup(formId) {
    let group = bundleGroups.get(formId);

    if (group) return group;

    const form = document.getElementById(formId) || document.forms[formId];

    if (!form) return null;

    const idInput = form.querySelector('input[name="id"]');
    if (!idInput) return null;

    const productIdInput = form.querySelector('input[name="product-id"]');
    const variantPicker = findVariantPickerByFormId(formId);

    group = {
      formId,
      form,
      idInput,
      productIdInput,
      variantPicker,
      standardVariantId:
        variantPicker?.selectedVariant?.id != null
          ? String(variantPicker.selectedVariant.id)
          : String(idInput.value || ""),
      defaultProductId: "",
      members: new Set(),
      onIdInputChange: null,
      onVariantChange: null,
    };

    group.onIdInputChange = () => {
      syncActiveMemberFromInput(group);
    };

    group.onVariantChange = (event) => {
      const variantId = event?.detail?.variant?.id;
      if (variantId != null) {
        group.standardVariantId = String(variantId);
      }
    };

    idInput.addEventListener("change", group.onIdInputChange);
    form.addEventListener("variant:change", group.onVariantChange);

    bundleGroups.set(formId, group);

    return group;
  }

  function cleanupGroup(formId) {
    const group = bundleGroups.get(formId);
    if (!group || group.members.size > 0) return;

    if (group.idInput && group.onIdInputChange) {
      group.idInput.removeEventListener("change", group.onIdInputChange);
    }

    if (group.form && group.onVariantChange) {
      group.form.removeEventListener("variant:change", group.onVariantChange);
    }

    bundleGroups.delete(formId);
  }

  class ScProductBundle extends HTMLElement {
    connectedCallback() {
      this.onBundleClick = this.onBundleClick.bind(this);

      const formId = this.getAttribute("data-form");
      if (!formId) return;

      const group = getOrCreateGroup(formId);
      if (!group) return;

      this.group = group;
      group.members.add(this);

      if (!group.defaultProductId && this.dataset.productId) {
        group.defaultProductId = this.dataset.productId;
      }

      if (
        this.getAttribute("data-active") === "true" &&
        this.dataset.productId
      ) {
        group.defaultProductId = this.dataset.productId;
      }

      this.addEventListener("click", this.onBundleClick);
      syncActiveMemberFromInput(group);
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.onBundleClick);

      if (!this.group) return;

      const formId = this.group.formId;
      this.group.members.delete(this);
      this.group = null;
      cleanupGroup(formId);
    }

    onBundleClick() {
      if (!this.group || !this.group.idInput) return;

      const currentProductId = getCurrentProductId(this.group);
      const isCurrentProductBundle =
        !!currentProductId && this.dataset.productId === currentProductId;

      if (isCurrentProductBundle) {
        const variantPicker =
          this.group.variantPicker ||
          findVariantPickerByFormId(this.group.formId);

        if (variantPicker) {
          this.group.variantPicker = variantPicker;
        }

        const standardVariantId =
          variantPicker?.selectedVariant?.id != null
            ? String(variantPicker.selectedVariant.id)
            : this.group.standardVariantId;

        if (standardVariantId) {
          setFormVariant(this.group, standardVariantId);
        } else {
          syncActiveMemberFromInput(this.group);
        }

        return;
      }

      if (this.dataset.variantId) {
        setFormVariant(this.group, this.dataset.variantId);
      }
    }
  }

  customElements.define("sc-product-bundle", ScProductBundle);
}

(function () {
  const SPEC_SKU_LABELS = [
    "artikelnummer",
    "sku",
    "référence",
    "codice articolo",
    "número de artículo",
    "numer artykułu",
  ];

  function setSkuElementText(element, sku) {
    const prefix =
      element.getAttribute("data-sc-variant-sku-prefix") ||
      (element.classList.contains("sc-product-title-sku") ? "SKU: " : "");
    const hasSku = Boolean(sku);

    element.textContent = hasSku ? `${prefix}${sku}` : "";
    element.toggleAttribute("hidden", !hasSku);
  }

  function updateSpecTableSku(sku) {
    document.querySelectorAll(".spec-table tr").forEach((row) => {
      const cells = row.querySelectorAll("td");
      if (cells.length < 2) return;

      const valueCell = cells[cells.length - 1];
      if (valueCell.hasAttribute("data-sc-variant-sku")) {
        valueCell.textContent = sku;
        return;
      }

      const label = cells[0].textContent.replace(/\s+/g, " ").trim().toLowerCase();
      if (!SPEC_SKU_LABELS.includes(label)) return;

      valueCell.setAttribute("data-sc-variant-sku", "");
      valueCell.textContent = sku;
    });
  }

  document.addEventListener("variant:changed", (event) => {
    const sku = event.detail?.variant?.sku || "";

    document
      .querySelectorAll("[data-sc-variant-sku], .sc-product-title-sku")
      .forEach((element) => {
        if (element.closest(".spec-table")) return;
        setSkuElementText(element, sku);
      });

    document.querySelectorAll(".product-meta__sku-number").forEach((element) => {
      element.textContent = sku;
      const wrap = element.closest(".product-meta__sku");
      if (wrap) wrap.toggleAttribute("hidden", !sku);
    });

    updateSpecTableSku(sku);
  });
})();
